module.exports = __webpack_public_path__ + "img/pr-1.1510e075.png";